import {formatDateTime} from "./formatDateTime";

export const formatTime = (date: Date, format: string = "hh.mm"): string => {
  return formatDateTime(date, format);
};